<i18n src="./resources/locales.json"></i18n>

<template>
  <v-btn class="primary-button mr-4" dark color="custom-primary">
    <v-icon left small>mdi-message-bulleted-off</v-icon>{{ $t('endChat') }}
  </v-btn>
</template>

<script>
export default {
  name: 'EcsCustomerActions'
};
</script>

<style scoped>
.primary-button {
  height: 28px !important;
}
</style>
